import type { FunnelPageProductInfo } from '../../../types';
import { FunnelJourneyCompletionCard } from './FunnelJourneyCompletionCard';
import { FunnelJourneyPageCard } from './FunnelJourneyPageCard';
import type { FunnelJourneyPreviewState } from './useFunnelJourneyPreview';

interface FunnelJourneyPreviewProps {
    state: FunnelJourneyPreviewState;
    productInfoByPageId: Record<number, FunnelPageProductInfo | undefined>;
    onExit: () => void;
}

export const FunnelJourneyPreview = ({ state, productInfoByPageId, onExit }: FunnelJourneyPreviewProps) => {
    if (state.publishedPages.length === 0) {
        return (
            <div className='bg-canvas shadow-stan flex flex-1 flex-col items-center justify-center gap-3 rounded-2xl p-12'>
                <p className='text-body-md text-gray text-center'>
                    Publish at least one page to preview the buyer journey.
                </p>
            </div>
        );
    }

    if (state.isComplete) {
        return (
            <FunnelJourneyCompletionCard
                history={state.history}
                publishedPages={state.publishedPages}
                earnedCents={state.earnedCents}
                currency={state.currency}
                productInfoByPageId={productInfoByPageId}
                onRestart={state.onRestart}
                onExit={onExit}
            />
        );
    }

    if (!state.currentPage) return null;

    const stepNumber = state.positionByPageId.get(state.currentPage.page_id) ?? state.currentPage.order;
    const relationship = state.relationshipByPageId.get(state.currentPage.page_id);

    return (
        <div className='flex flex-col gap-4'>
            <div className='flex flex-col gap-1'>
                <p className='text-heading-h3 text-dark'>Buyer Journey Preview</p>
                <p className='text-body-sm text-gray'>Simulate how customers move through this funnel step.</p>
            </div>

            <FunnelJourneyPageCard
                key={state.currentPage.page_id}
                page={state.currentPage}
                productInfo={productInfoByPageId[state.currentPage.page_id]}
                stepNumber={stepNumber}
                totalSteps={state.positionByPageId.size}
                relationship={relationship}
                isFirstStep={stepNumber === 1}
                onBuy={state.onBuy}
                onSkip={state.onSkip}
            />
        </div>
    );
};
